import { AddOtherChargesAPIResponse, BaseReducerState } from '../../../services'
import { ActionTypes } from '../actions'

export type AddOtherChargesState = BaseReducerState & {
  data: boolean
}

const addOtherChargesInitiaState: AddOtherChargesState = {
  loading: false,
  success: false,
  message: '',
  data: null,
  error: null,
}

export const addOtherCharges = (
  state: AddOtherChargesState = addOtherChargesInitiaState,
  action: { type: string; res: any }
): AddOtherChargesState => {
  switch (action.type) {
    case `${ActionTypes.ADD_OTHER_CHARGES}_REQUEST`:
      return {
        ...state,
        loading: true,
        success: false,
        message: null,
        data: null,
        error: null,
      }

    case `${ActionTypes.ADD_OTHER_CHARGES}_SUCCESS`: {
      const { success, data, message } = <AddOtherChargesAPIResponse>action.res
      return {
        ...state,
        loading: false,
        success,
        message,
        ...(success && data && { data }),
      }
    }
    case `${ActionTypes.ADD_OTHER_CHARGES}_FAILURE`:
      const res = <AddOtherChargesAPIResponse>action.res
      const { message } = res || {}
      res.error ??= message
      const { error } = res
      return {
        ...state,
        loading: false,
        success: false,
        message,
        error,
      }

    case `${ActionTypes.ADD_OTHER_CHARGES}_RESET`:
      return {
        ...state,
        loading: false,
        success: false,
        message: null,
        data: null,
        error: null,
      }
  }
  return state
}
